import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../layout/Header';
import Sidebar from '../layout/Sidebar';
import Footer from '../../admin-panel/layout/Footer';

const SuperAdminLayout = () => {
    useEffect(() => {
        const html = document.documentElement;

        html.setAttribute('data-layout', 'vertical');
        html.setAttribute('data-topbar', 'light');
        html.setAttribute('data-sidebar', 'dark');
        html.setAttribute('data-layout-style', 'default');
        html.setAttribute('data-layout-position', 'fixed');
        html.setAttribute('data-layout-width', 'fluid');

        if (!html.getAttribute('data-sidebar-size')) {
            html.setAttribute('data-sidebar-size', 'lg');
        }

        if (window.init) {
            window.init();
        }
        if (window.feather) {
            window.feather.replace();
        }

        return () => {
            html.removeAttribute('data-layout');
            html.removeAttribute('data-sidebar-size');
            html.removeAttribute('data-topbar');
            html.removeAttribute('data-sidebar');
            html.removeAttribute('data-layout-style');
            html.removeAttribute('data-layout-position');
            html.removeAttribute('data-layout-width');
            document.body.classList.remove('vertical-sidebar-enable');
        };
    }, []);

    return (
        <div id="layout-wrapper">
            <Header /> 
            <Sidebar /> 
            <div className="vertical-overlay" onClick={() => document.body.classList.remove("vertical-sidebar-enable")}></div>
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <Outlet />
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    );
};

export default SuperAdminLayout;
